import dayjs from '@/util/dayjs';

export function utcConvert(date) {
    return dayjs(date).utc().format('YYYY-MM-DD HH:mm:ss');
}